/* eslint-disable react/prefer-stateless-function */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getMatchTimelineEvents, getTimezone } from '../../selectors/common';
import { getMatchTimeline } from '../../selectors/matchTimeline';
import { getDateTime } from '../../utils/common';

const mapToProps = (state) => ({
  matchTimeline: getMatchTimeline(state),
  getTimezone: getTimezone(state),
  matchTimelineEvents: getMatchTimelineEvents(state),

});

class TableStartHeader extends Component {
  render() {
    const startHeader = this.props.matchTimeline.find((event) => event.eventType
      === this.props.period);
    const eventName = this.props.matchTimelineEvents[this.props.period];
    if (startHeader) {
      const time = getDateTime(startHeader.dateTime, this.props.getTimezone).split(' ')[1].replace(/:/g, ' : ');

      return (
        <tr>
          <th>{time}</th>
          <th>&nbsp;</th>
          <th>{eventName}</th>
          <th>&nbsp;</th>
          <th>&nbsp;</th>
        </tr>
      );
    }
    return null;
  }
}

export default connect(mapToProps)(TableStartHeader);
